import React from 'react';
import {
  Alert, Button, LinearProgress, Typography,
} from '@mui/material';
import { useZeny } from './ZenyProvider';
import brand from '../shell/brand';

const ZenyStatus = () => {
  const { error, updatedAt, loading, refresh } = useZeny();
  return (
    <>
      {loading && <LinearProgress aria-label={`Refreshing ${brand.assistant} issues`} sx={{ mb: 1 }} />}
      {error && (
        <Alert severity="warning" action={<Button color="inherit" onClick={refresh} disabled={loading}>Retry</Button>} sx={{ mb: 2 }}>
          {updatedAt
            ? `${brand.assistant} updates are unavailable. Showing the last received issues.`
            : `${brand.assistant} is unavailable. Issue counts are unknown.`}
        </Alert>
      )}
      {updatedAt && (
        <Typography variant="caption" color="text.secondary" component="p" sx={{ mb: 2 }}>
          {`Last updated ${new Date(updatedAt).toLocaleTimeString()}${error ? ' · Data may be stale' : ''}`}
        </Typography>
      )}
    </>
  );
};
export default ZenyStatus;
